import React from 'react';

const DashbboardContabilidade = () => <div>Dashboard contabilidade</div>;

export default DashbboardContabilidade;
